
import { FC, useEffect, useState } from "react";

import DOMPurify from "dompurify";
import { useModalOpener } from "hooks/helpers/useModalOpener";

import { templates, Question } from "../../constants/questions";
import PromptModal from "../Shared/PromptModal";

interface YesNoQuestionProps {
    data: Question;
    onAnswer: (_question: string, _answer: any, _questionType?: string) => void;
    initialValue: string | undefined;
    insertItemName?: boolean;
    itemName?: string;
}

const YesNoQuestion: FC<YesNoQuestionProps> = ({ data, onAnswer, initialValue, insertItemName, itemName }) => {
    const [selectedAnswer, setSelectedAnswer] = useState("");

    const {
        isOpened: isQuestionHelpModalOpened,
        open: handleQuestionHelpOpenModal,
        close: handleQuestionHelpCloseModal,
    } = useModalOpener();

    const handleSelection = (answer: "yes" | "no") => {
        setSelectedAnswer(answer);
        onAnswer(data.question, answer);
    };

    const getButtonClass = (answer: "yes" | "no") =>
        `shared__secondary-button ${selectedAnswer === answer ? "selected" : ""}`;

    useEffect(() => {
        setSelectedAnswer(initialValue || "");
    }
    , [initialValue]);

    return (
        <div className="new-questionnaire__question">
            {data.questionTitle && (
                <div className="new-questionnaire__list-question-title">{data.questionTitle}</div>
            )}

            <div className="new-questionnaire__question-text" style={data.questionTitle ? { margin: "4px auto" } : {}}>

                {data.question &&
                <span
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize((insertItemName && itemName)
                            ? data.question.replace(templates.itemName, itemName)
                            : data.question),
                    }}
                />
                }
                {data.promptModal &&
                <span className="shared__learn-more" onClick={handleQuestionHelpOpenModal}>
                        Learn more
                </span>
                }

            </div>

            {data.infoText && <div className="new-questionnaire__info-text">
                {data.infoText}
            </div>}

            <div className="flex-row gap16 mt20">
                <div
                    className={getButtonClass("yes")}
                    onClick={() => handleSelection("yes")}
                >
                    <span>Yes</span>
                </div>
                <div
                    className={getButtonClass("no")}
                    onClick={() => handleSelection("no")}
                >
                    <span>No</span>
                </div>
            </div>
            {isQuestionHelpModalOpened && (
                <PromptModal
                    isOpen={isQuestionHelpModalOpened}
                    closeModal={handleQuestionHelpCloseModal}
                    data={{
                        title: data.promptModal?.title || "",
                        text: data.promptModal?.text || "",
                        image: data.promptModal?.image,
                        promptActionButtonText: data.promptModal?.promptActionButtonText,
                        promptActionButtonUrl: data.promptModal?.promptActionButtonUrl,
                    }}
                    handlePrev={() => {}}
                />
            )}
        </div>
    );
};

export default YesNoQuestion;
